import { render, staticRenderFns } from "./StatsEmailTab.vue?vue&type=template&id=13fdcdc4&scoped=true&"
import script from "./StatsEmailTab.vue?vue&type=script&lang=js&"
export * from "./StatsEmailTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsEmailTab.vue?vue&type=style&index=0&id=13fdcdc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fdcdc4",
  null
  
)

export default component.exports